/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';

import messages from 'src/shared/app/moderation/l10n/zmoderationL10n';
import LazyOwnTopicsMain from 'src/shared/app/account/base/component/LazyOwnTopicsMain';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { ownTopicsRoute } from 'src/shared/app/base/route/setting/routeSettings';
import Notification from 'src/shared/app/notification/component/Notification';

type Props = {
  handleDismiss: () => void,
};

const ModerationRejectedNotificationDumb = ({
  handleDismiss,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const [ownTopicsPath] = useRoutes(ownTopicsRoute);

  /*
   |----------------------------------------------------------------------------
   | Effects
   |----------------------------------------------------------------------------
   */

  React.useEffect(() => {
    LazyOwnTopicsMain.preload();
  }, []);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <Notification
      withWarning
      href={ownTopicsPath}
      handleDismiss={handleDismiss}
      timeout={8000}
    >
      {intl.formatMessage(messages.moderationRejectedNotification)}
    </Notification>
  );
};

export default React.memo<Props>(ModerationRejectedNotificationDumb);
